import useEffectOnce from "hooks/useEffectOnce";
import { CraftIdentityContext } from "pages/CraftIdentity";
import { CraftPredictionContext } from "pages/CraftPrediction";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { createAPI } from "services/api/api";
import { setRarity } from "store/crafting";

const rarityConfig = {
  identity: {
    initialState: {
      month_rarity: null,
      day_rarity: null,
      year_rarity: null,
      category_rarity: null,
    },
    keys: ['month_rarity', 'day_rarity', 'year_rarity', 'category_rarity'],
  },
  prediction: {
    initialState: {
      event_rarity: null,
      identity_rarity: null,
      trigger_rarity: null,
      prize_rarity: null,
    },
    keys: ['event_rarity', 'identity_rarity', 'trigger_rarity', 'prize_rarity'],
  }
};

const CraftBlockRarity = () => {
  const { pathname } = useLocation();
  const api = createAPI();
  const dispatch = useDispatch();
  const { rarity } = useSelector((state) => state.crafting);

  const getContext = () => {
    return pathname.includes('identity') ? CraftIdentityContext : CraftPredictionContext;
  };

  const { craftBlocks } = useContext(getContext());
  const currentConfig = pathname.includes('identity') ? rarityConfig.identity : rarityConfig.prediction;

  const [calculation, setCalculation] = useState(currentConfig.initialState);

  const getCalculation = () => {
    const newCalculation = { ...calculation };

    currentConfig.keys.forEach((key, index) => {
      if (craftBlocks[index]?.value) {
        newCalculation[key] = craftBlocks[index].value.rarity;
      } else {
        newCalculation[key] = null;
      }
    });

    return newCalculation;
  };

  const buildQueryParams = (obj) => {
    return Object.entries(obj)
      .filter(([_, value]) => value !== null)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
  };

  const rarityCalcultation = async (newCalc) => {
    if (craftBlocks.filter(block => block.value !== null).length >= 2) {
      try {
        const response = await api.get(`/me/${pathname.includes('identity') ? 'identity_rarity' : 'prediction_rarity'}/params?${buildQueryParams(newCalc)}`);
        dispatch(setRarity(response.data.name));
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    const newCalculation = getCalculation();

    if (craftBlocks.filter(block => block.value === null).length > 2) {
      dispatch(setRarity('Slot two or more cards'));
    } else {
      setCalculation(() => {
        rarityCalcultation(newCalculation);
        return newCalculation
      });
    }

  }, [craftBlocks]);

  useEffectOnce(() => {
    setCalculation(currentConfig.initialState);
  });

  return (
    <span className="craft-block__tip">
      Crafted Rarity: {rarity}
      <span>Rarity calculator shows the rarity of the card to be crafted</span>
    </span>
  );
};

export default CraftBlockRarity;
